import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import shouldPureComponentUpdate from 'react-pure-render/function';
import './SearchUnitHotelName.scss';

export default class SearchUnitHotelName extends Component {
  static propTypes = {
    isDisabled: PropTypes.bool,
    onInputChange: PropTypes.func.isRequired,
    queryValue: PropTypes.string,
  };

  static defaultProps = {
    hasNoResults: true,
    queryValue: '',
    isDisabled: false,
  };

  /* istanbul ignore next */
  shouldComponentUpdate = shouldPureComponentUpdate;

  saveComponentRef = ref => this.linkRef = ref;

  onInputChange = (event) => {
    const { onInputChange } = this.props;
    onInputChange(event, ReactDOM.findDOMNode(this.linkRef));
  }

  render() {
    const {
      isDisabled,
      queryValue,
    } = this.props;

    return (
      <div className="search-unit-hotel-name" ref={this.saveComponentRef}>
        <div className={`search-unit-hotel-name__inner ${isDisabled ? 'search-unit-hotel-name__inner--is-disabled' : ''}`} >
          <input
            type="text"
            onChange={this.onInputChange}
            className="search-unit-hotel-name__input"
            placeholder="Start typing a hotel name"
            value={queryValue}
          />
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchUnitHotelName/SearchUnitHotelName.jsx
 **/